(function() {
  'use strict';
  angular.module('common')
  .directive('challengeResponses', [function() {
    return {
      controller: function() {
        let scopes = {};
        let originalModel = [{},{},{}];
        this.register = function register(scope) {
          scopes[scope.$id] = scope;
          if (scope.index && scope.model) {
            originalModel[scope.index] = angular.copy(scope.model);
          }
        };
        this.unregister = function unregister(scope) {
          delete scopes[scope.$id];
        };
        this.otherChallenges = function($scope) {
          return _.map(_.filter(scopes, (scope, id) => {
            return id != $scope.$id && scope.model && scope.model.challenge;
          }), (scope) => {
            return scope.model.challenge;
          });
        };
        this.originalChallenge = function(index){
          return originalModel[index].challenge;
        };
      }
    };
  }])
  .directive('challengeResponse', [function(){
    return {
      scope: {
        model: '=', //The object passed will get a challenge and response property
        index: '@', //For id attributes, for attributes on labels
        challenges: '=', //An array of challenges for the dropdown
        isUpdate: '@' // attrubute indicating updates on existing challenges & responses
      },
      require: '^challengeResponses',
      templateUrl: '/js/common/challengeResponse.html' + appVersion,
      link: function($scope, element, attrs, challengeResponsesCtrl) {
        challengeResponsesCtrl.register($scope);
        $scope.$on('$destroy', () => challengeResponsesCtrl.unregister($scope));
        $scope.responseRequired = [];
        $scope.$watchCollection(() => {
          return challengeResponsesCtrl.otherChallenges($scope);
        }, (otherChallenges) => {
          $scope.otherChallenges = otherChallenges;
          $scope.unusedChallenges = _.difference($scope.challenges, otherChallenges);
        }, true);

        var watch = $scope.$watchCollection('challenges', (challenges) => {
          $scope.unusedChallenges = _.difference($scope.challenges, $scope.otherChallenges);
          $scope.challenges && challenges.length && watch();
        });

        if ($scope.isUpdate) {
            $scope.$watch(()=> {
              return $scope.model.challenge;
            }, (newChallenge, oldChallenge) => {
              if (newChallenge === challengeResponsesCtrl.originalChallenge($scope.index)){
                $scope.responseRequired[$scope.index] = false;
              }else if (newChallenge != oldChallenge) {
                $scope.responseRequired[$scope.index] = true;
                $scope.model.response='';
              }
            });
            $scope.$watch(()=> {
               return $scope.model.response;
            }, (newResponse, oldResponse) => {
               $scope.responseRequired[$scope.index] = (newResponse === '' &&
                                                       $scope.model.challenge === challengeResponsesCtrl.originalChallenge($scope.index)) ? false:true;  
            });
        }
      }
    };
  }]);
})();
